import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './StackItem.module.css';

const bindClasses = classNameBind.bind(styles);

const StackItem = ({
  children,
  fill,
  previousSpacing,
  wrap,
  dataId,
  fillLight,
}) => (
  <div
    className={bindClasses(
      'wrapper',
      previousSpacing ? `spacing-${previousSpacing}` : null,
      {
        '-fill': fill,
        '-wrap': wrap,
        '-fill-light': fillLight,
      },
    )}
    data-ppuc-id={dataId}
  >
    {children}
  </div>
);

StackItem.defaultProps = {
  children: null,
  fill: false,
  wrap: false,
  fillLight: false,
  previousSpacing: null,
  dataId: 'StackItem',
};

StackItem.displayName = 'Stack.Item';

export default StackItem;
